var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUploadImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22134_57911)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 4.49967C14.943 4.49967 15.1668 4.27582 15.1668 3.99967C15.1668 3.72353 14.943 3.49967 14.6668 3.49967V3.99967V4.49967ZM9.3335 3.49967C9.05735 3.49967 8.8335 3.72353 8.8335 3.99967C8.8335 4.27582 9.05735 4.49967 9.3335 4.49967V3.99967V3.49967ZM12.5002 1.33301C12.5002 1.05687 12.2763 0.833008 12.0002 0.833008C11.724 0.833008 11.5002 1.05687 11.5002 1.33301L12.0002 1.33301H12.5002ZM11.5002 6.66634C11.5002 6.94248 11.724 7.16634 12.0002 7.16634C12.2763 7.16634 12.5002 6.94248 12.5002 6.66634H12.0002H11.5002ZM14.6668 3.99967V3.49967L12.0002 3.49967V3.99967V4.49967L14.6668 4.49967V3.99967ZM12.0002 3.99967V3.49967L9.3335 3.49967V3.99967V4.49967H12.0002V3.99967ZM12.0002 1.33301L11.5002 1.33301V3.99967H12.0002L12.5002 3.99967V1.33301H12.0002ZM12.0002 3.99967H11.5002L11.5002 6.66634H12.0002H12.5002L12.5002 3.99967L12.0002 3.99967Z",
    fill: "#242429"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66683 2C4.68127 2 3.18849 2 2.26099 2.9275C1.3335 3.85499 1.3335 5.34777 1.3335 8.33333C1.3335 11.3189 1.3335 12.8117 2.26099 13.7392C3.18849 14.6667 4.68127 14.6667 7.66683 14.6667C10.6524 14.6667 12.1452 14.6667 13.0727 13.7392C14.0002 12.8117 14.0002 11.3189 14.0002 8.33333V8",
    stroke: "#242428",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3335 9.4233C1.74617 9.36336 2.16339 9.33375 2.58131 9.33479C4.34927 9.29743 6.07392 9.84831 7.44755 10.8891C8.7215 11.8544 9.61665 13.1829 10.0002 14.6663",
    stroke: "#242428",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 11.2635C13.2164 10.8666 12.4058 10.6652 11.5908 10.6661C10.3563 10.6612 9.13435 11.1149 8 11.9993",
    stroke: "#242428",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22134_57911"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUploadImage);
export default __webpack_public_path__ + "static/media/icon-upload-image.1e76075e33ef274a9d1bf01305cd9347.svg";
export { ForwardRef as ReactComponent };